import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HandleHttpError } from './error.handler';
import { PreRegistrationModel } from '../models/pre-registration.model';
import { SharedService } from './shared.service';

@Injectable()
export class RegistrationService {

    baseURL: string;

    constructor(private http: HttpClient, private sharedService: SharedService) {
        this.baseURL = this.sharedService.getBaseURL();
    }


    createStudent(registrationModel: PreRegistrationModel): Observable<any> {
        return this.http.post(`${this.baseURL}/students`, registrationModel)
                    .pipe(catchError(err => HandleHttpError(err)));
    }

    validatePreRegistrationStudentDetails(registrationModel: PreRegistrationModel): Observable<any> {
        return this.http.post(`${this.baseURL}/students/validate`, registrationModel)
                    .pipe(catchError(err => HandleHttpError(err)));
    }

    ValidateRegisteredWithSelectedNationality(countryOfNationalityId: string): Observable<any> {
        return this.http.get(`${this.baseURL}/students/ValidateRegisteredWithSelectedNationality?countryOfNationalityId=${countryOfNationalityId}`)
                    .pipe(catchError(err => HandleHttpError(err)));
    }

    registerStudent(username: string): Observable<any> {
        return this.http.post(`${this.baseURL}/registrations/`, { 'UserName': username })
                    .pipe(catchError(err => HandleHttpError(err)));
    }

    verifyStudentRegistration(username: string): Observable<any> {
        return this.http.post(`${this.baseURL}/registrations/account-verified`, { 'UserName': username })
                    .pipe(catchError(err => HandleHttpError(err)));
    }

    verifyAgentRegistration(username: string): Observable<any> {
        return this.http.post(`${this.baseURL}/registrations/account-verified`, { 'UserName': username })
                    .pipe(catchError(err => HandleHttpError(err)));
    }

}
